import React from 'react';
import { Checkbox, FormControlLabel, Tooltip } from '@mui/material';

interface BakeasyCheckboxProps {
  label: string;
  disabled?: boolean;
  fullWidth?: boolean;
  variant?: any;
  style?: React.CSSProperties;
  value: boolean | false;
  checked?: string | any;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  tooltipTitle?: any;
}

function BakeasyCheckbox(props: BakeasyCheckboxProps) {
  return (
    <Tooltip title={props.tooltipTitle}>
      <FormControlLabel
        sx={{
          ...(props?.style ?? {})
        }}
        control={
          <Checkbox
            onClick={props?.onClick}
            checked={props?.value}
            onChange={props?.onChange}
            size="small"
          />
        }
        label={props?.label}
        disabled={props?.disabled}
        disableTypography={true}
      />
    </Tooltip>
  );
}

export default BakeasyCheckbox;
